import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * ProtectedRoute component
 * Restricts access to authenticated users with verified emails and phones
 */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  // Show loading state if auth is still being checked
  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!user.email_verified) {
    // If the email is not verified make sure we're on the verify-email page
    return currentPath === '/verify-email' ? children : <Navigate to="/verify-email" />;
  }

  if (!user.phone_verified) {
    // If the phone is not verified make sure we're on the verify-phone page
    return currentPath === '/verify-phone' ? children : <Navigate to="/verify-phone" />;
  }

  // If the user is authenticated and has verified email and phone, render the children
  return children;
}

export default ProtectedRoute;